import { render, staticRenderFns } from "./workflow-triggers.vue?vue&type=template&id=5ee39258"
import script from "./workflow-triggers.vue?vue&type=script&lang=js"
export * from "./workflow-triggers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports